import Vue from 'vue'
import router from '../../router'

// state
export const state = {
  token: localStorage.getItem("access_token"),
  user: null,
  error: null
}

// getters
export const getters = {
  check: state => !!state.user,
  token: state => state.token,
  user: state => state.user || {},
  isAdmin: state => {
    if (!state.user) return false
    return state.user.roles.includes('admin')
  },
  error: state => state.error
}

// mutations
export const mutations = {
  success: (state, token) => { state.token = token, localStorage.setItem('access_token', token) },
  saveUser: (state, user) => {

    user.hasRoles = roles => {
      return roles.some(role => user.roles.includes(role));
    }

    state.user = user
  },

  clean: state => {
    localStorage.removeItem('access_token');
    state.token = null;
    state.user = null;
  },
  error: (state, error) => {
    if (error)
      state.error = error.response.data.message;
    else state.error = null;
  }
}

// actions
export const actions = {
  async login({ commit, dispatch, state }, user) {
    try {
      const { data } = await Vue.axios.post('/oauth/token', user);
      commit('success', data.access_token);
      await dispatch('getUser');

      if (state.user.hasRoles(['admin', 'finance', 'reception'])) {
        router.push('/');
      } else if (state.user.hasRoles(['doctor'])) {
        router.push('/doctor/appointments')
      } else {
        router.push('/' + state.user.roles[0]);
      }

    } catch (error) {
      commit('clean');
      commit('error', error);
    }
  },

  async logout({ commit, state }) {
    // await Vue.axios.delete('/oauth/tokens/' + state.token);
    commit('clean')

    router.push('/login');
  },

  // user
  async getUser({ commit }) {
    try {
      const { data } = await Vue.axios.get('/api/user');
      commit('saveUser', data.data);
      commit('error', null);

    } catch (error) {
      commit('clean');
      commit('error', error)
    }
  },
}